<script lang="ts">
  import 'smelte/src/tailwind.css';

  import Game from './pages/Game.svelte';
</script>

<style>
  main {
    width: 100%;
    height: 100%;
    text-align: center;
    padding: 1em;
    margin: 0 auto;
  }
</style>

<main>
  <Game />
</main>
